export { TabComponents } from "./TabComponents";
export { TabFooter } from "./TabFooter";
